import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl, Validators } from '@angular/forms';
import { FormService } from '../../form.service';
import { Option } from '../../interfaces/option-interface';
import { BaseControlValueAccessorComponent } from '../base-control-value-accessor/base-control-value-accessor.component';

@Component({
  selector: 'app-quantity',
  templateUrl: './quantity.component.html',
  styleUrls: ['./quantity.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QuantityComponent),
      multi: true,
    },
  ],
})
export class QuantityComponent extends BaseControlValueAccessorComponent implements OnInit {
  @Input() title!: string;
  @Input() options!: Array<Option>;
  @Input() required!: boolean;
  @Input() placeholder!: string | undefined;
  @Input() formControl = new UntypedFormControl();

  showError = false;

  constructor(public formService: FormService) {
    super();
  }

  ngOnInit(): void {
    if (this.required) {
      this.formControl.setValidators(Validators.required);
      this.formControl.updateValueAndValidity();
      this.placeholder += ' *';
    }
    if (this.formControl.value) return;

    const initialValue = this.options.reduce((acc: any, option) => {
      acc[option.id] = null;
      return acc;
    }, {});
    this.formControl.setValue(initialValue);
  }

  updateValue(optionId: string, event: EventTarget | null): void {
    if (this.formControl.untouched) {
      this.formControl.markAsTouched();
    }
    this.showError = false;
    const value = this.formControl.value;
    value[optionId] = (event as HTMLInputElement).value === '' ? null : +(event as HTMLInputElement).value;
    this.formControl.setValue(value);

    if (Object.values(this.formControl.value).some((value) => value === null || value === undefined)) {
      this.showError = true;
    }
  }

  onInputBlur(): void {
    if (this.formControl.untouched) {
      this.formControl.markAsTouched();
      this.showError = true;
    }
  }
}
